import { QueryKeys } from "@/constants/Query";
import { useApiMutation } from "@/hooks/useApiMutation";
import axiosInstance from "@/lib/axios";
import { useQueryClient } from "@tanstack/react-query";
import { useParams } from "@tanstack/react-router";
import type * as fhirTypes from "fhir/r4";

export const useToggleReferOut = ({
  encounterId,
  carePlanId,
}: {
  encounterId: string;
  carePlanId?: string;
}) => {
  const queryClient = useQueryClient();
  const { patientId } = useParams({ from: "/patient/$patientId" });
  return useApiMutation<fhirTypes.CarePlan, void>({
    mutationOptions: {
      mutationKey:
        QueryKeys.Patient.Chart.EpisodesOfCare.CarePlan.Referrals.TOGGLE,
      mutationFn: (params) => {
        return axiosInstance.put(
          `/amazon-clinic/care-plans/${carePlanId}/toggle`,
          params,
        );
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: QueryKeys.Patient.Chart.EpisodesOfCare.CarePlan.SUMMARY({
            patientId,
            encounterId,
          }),
        });
        queryClient.invalidateQueries({
          queryKey:
            QueryKeys.Patient.Chart.EpisodesOfCare.CarePlan.Recommendation.DEFAULT(
              {
                patientId,
                encounterId,
                carePlanId: carePlanId as string,
              },
            ),
        });
      },
    },
  });
};
